import { Progress } from "../../../../nq-component";
import CustomFormFactory from "../../../../components/CustomFormFactory/CustomFormFactory";
import PageContainer from "../../../../components/PageContainer/PageContainer";
import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import { restUseCase } from "../../../../usecases/rest";
import FormUtils from "../../../../utils/classUtils/FormUtils";
import withRouter from "../../../../utils/withRouter";
import EditProfileFormPresenter from "./EditProfileFormPresenter";

class EditProfileFormPage extends FormUtils {
  constructor(props) {
    super(props);
    this.state = { object: {}, modalState: false };
    this.presenter = new EditProfileFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
      restUseCase(),
    );
  }

  getCollectionName() {
    return "users";
  }

  render() {
    const { fields, sections } = this.getSchema(this.getCollectionName());

    console.log("f", fields);
    const { object } = this.state;

    console.log("obj", object);

    return (
      <PageContainer title="Edit Profile">
        {Object.keys(object).length < 1 ? (
          <Progress />
        ) : (
          <form onSubmit={this.onSubmitForm.bind(this)}>
            <CustomFormFactory
              schema={this.transformFieldsToSections({ fields, sections })}
              object={object}
              fieldsToExlude={[
                ...this.fieldsToExclude,
                "lockedTo",
                "status",
                "registrationStatus",
                "startDate",
                "password",
                "is_Delete",
                "approvedBy",
                "last_login_at",
                "last_logout_at",
              ]}
              fieldToDisable={["affiliate", "branch", "roles"]}
              onChange={this.onChange.bind(this)}
              navigateBack={this.navigateBack.bind(this)}
            />
          </form>
        )}
      </PageContainer>
    );
  }
}

export default withRouter(EditProfileFormPage);
